import React from "react";
import "./Skeleton.css";

export const SkeletonBlock = ({ width = "100%", height = 16, radius = 8, style }) => (
  <div
    className="skel-block"
    style={{ width, height, borderRadius: radius, ...style }}
    aria-hidden="true"
  />
);

export const SkeletonCircle = ({ size = 40, style }) => (
  <div
    className="skel-block skel-circle"
    style={{ width: size, height: size, ...style }}
    aria-hidden="true"
  />
);

export const SkeletonText = ({ lines = 1, width = "100%" }) => (
  <div className="skel-text" aria-hidden="true">
    {Array.from({ length: lines }).map((_, i) => (
      <div
        key={i}
        className="skel-block skel-text-line"
        style={{ width: i === lines - 1 && lines > 1 ? "60%" : width }}
      />
    ))}
  </div>
);
